import { Stack } from "@mui/material";

export default function BuyerSettings() {
  return (
    <Stack
      alignItems="flex-start"
      sx={{
        mt: "100px",
        pl: "40px",
      }}
    >
      <h1>Buyer Settings</h1>
    </Stack>
  );
}
